import { c as _c } from "react/compiler-runtime";
import UniversalLink from "library/link";
import { type ListNestMode, type MissingComponentHandler, PortableText, type PortableTextComponents } from "next-sanity";
import type { ReactNode } from "react";
import { withComponent } from "library/styled/withComponent";
import { DefaultNormal, DefaultH1, DefaultH2, DefaultH3, DefaultH4, DefaultH5, DefaultH6, DefaultBlockQuote, DefaultBullet, DefaultNumber, DefaultStrong, DefaultEm, DefaultCode, DefaultUnderline, DefaultStrikeThrough, DefaultSuper, DefaultSub, DefaultLink as DefaultLink___raw } from "data:text/javascript;base64,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";
type PossibleMarks = "strong" | "em" | "code" | "underline" | "strike-through" | "super" | "sub";
type Input = {
  _type: string;
  _key?: string;
  style?: string;
  list?: string;
  listItem?: string;
  markDefs?: Array<{
    _type: string;
  }> | null;
};
type UnionToIntersection<U> = (U extends unknown ? (x: U) => void : never) extends ((x: infer I) => void) ? I : never;
type ValueComponent<V = never> = ({
  children,
  value
}: {
  children: ReactNode;
  value: V;
}) => ReactNode;
type GetMarkDefinition<Item extends Input> = Item extends unknown ? Item["_type"] extends "block" ? {
  block?: NonNullable<Item["style"]> extends string ? { [style in NonNullable<Item["style"]>]?: ValueComponent<Item> } : undefined;
  list?: NonNullable<Item["listItem"]> extends string ? { [listItem in NonNullable<Item["listItem"]>]: ValueComponent<Item> } : undefined;
  listItem?: NonNullable<Item["listItem"]> extends string ? { [listItem in NonNullable<Item["listItem"]>]: ValueComponent<Item> } : undefined;
  marks?: { [mark in PossibleMarks]?: ValueComponent } & { [customMark in NonNullable<Item["markDefs"]>[number] as customMark["_type"]]?: ValueComponent<customMark> };
} : {
  types: { [itemType in Exclude<Item["_type"], "block">]: ValueComponent<Item & {
    _type: itemType;
  }> };
} : never;
type GetComponents<T extends Input> = UnionToIntersection<GetMarkDefinition<T>>;
export const TypedPortableText = t0 => {
  const $ = _c(18);
  const {
    value,
    components,
    listNestingMode,
    onMissingComponent
  } = t0;
  if (!value) {
    return null;
  }
  let t1;
  if ($[0] !== components) {
    t1 = components ?? {};
    $[0] = components;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cast = t1 as Partial<PortableTextComponents>;
  let t2;
  if ($[2] !== cast.block) {
    t2 = {
      ...defaultBlocks,
      ...cast.block
    };
    $[2] = cast.block;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== cast.list) {
    t3 = {
      ...defaultList,
      ...cast.list
    };
    $[4] = cast.list;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== cast.marks) {
    t4 = {
      ...defaultMarks,
      ...cast.marks
    };
    $[6] = cast.marks;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== cast || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = {
      ...cast,
      block: t2,
      list: t3,
      marks: t4
    };
    $[8] = cast;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = t5 as unknown as PortableTextComponents;
  let t7;
  if ($[13] !== listNestingMode || $[14] !== onMissingComponent || $[15] !== t6 || $[16] !== value) {
    t7 = <PortableText value={value} components={t6} listNestingMode={listNestingMode} onMissingComponent={onMissingComponent} />;
    $[13] = listNestingMode;
    $[14] = onMissingComponent;
    $[15] = t6;
    $[16] = value;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
const defaultBlocks = {
  normal: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultNormal>{children}</DefaultNormal>,
  h1: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultH1>{children}</DefaultH1>,
  h2: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultH2>{children}</DefaultH2>,
  h3: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultH3>{children}</DefaultH3>,
  h4: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultH4>{children}</DefaultH4>,
  h5: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultH5>{children}</DefaultH5>,
  h6: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultH6>{children}</DefaultH6>,
  blockquote: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultBlockQuote>{children}</DefaultBlockQuote>
};
const defaultList = {
  bullet: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultBullet>{children}</DefaultBullet>,
  number: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultNumber>{children}</DefaultNumber>
};
const DefaultLink = withComponent(UniversalLink, DefaultLink___raw);
const defaultMarks = {
  strong: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultStrong>{children}</DefaultStrong>,
  em: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultEm>{children}</DefaultEm>,
  code: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultCode>{children}</DefaultCode>,
  underline: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultUnderline>{children}</DefaultUnderline>,
  "strike-through": ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultStrikeThrough>{children}</DefaultStrikeThrough>,
  super: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultSuper>{children}</DefaultSuper>,
  sub: ({
    children
  }: {
    children: ReactNode;
  }) => <DefaultSub>{children}</DefaultSub>,
  link: ({
    value,
    children
  }: {
    value: {
      href?: string;
      _type: "link";
      _key: string;
    };
    children: ReactNode;
  }) => value.href ? <DefaultLink href={value.href}>{children}</DefaultLink> : <>{children} (empty link)</>
};